import { IUserSettings } from "./Services/UserSettingsStore";

export interface IAppSettings extends IUserSettings {
    apiUrl: string;
    accessToken: string;
    pinLen: number;
    honeywellLib: string;
    cognexLib: string;
    minSearchChars: number;
    showRetryOnScanError: boolean;
    searchLimit: number;
    minStatsUpdateInterval: number;
    useCanvas?: boolean;
    quickStatsTimeout: number;
    multiScanSameCodeTimeout: number;
    monitorUpdateInterval: number;
    lmApiUrl: string;
}

export var appSettings: IAppSettings;

export async function loadAppSettingsAsync() {
    appSettings = await (await fetch(`/settings.json`)).json();
}
